// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"k0-z","dimensionLabel":"l0-z","styleChooserControlWrapper":"m0-z","styleChooserControl":"n0-z","disabled":"o0-z","giftCard":"p0-z","styleChooserText":"q0-z"};